// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createStoreSampleRequests = (client) => ({
    /**
     * `POST /store/sample-requests/:id/feedback`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreSampleRequestsIdFeedbackCreate
     * @source packages/modules/b2c-core/src/api/store/sample-requests/[id]/feedback/route.ts
     */
    updateFeedback: (id, body, query, headers) => client.fetch(buildPath("/store/sample-requests/:id/feedback", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=sample-requests.js.map